import React from 'react';
import { withRouter } from 'react-router';
import GetBookingQuery from './GetBookingQuery';

const withBooking = (
  Component,
  query,
  options = {
    centerLoader: false
  }
) =>
  withRouter((props) => {
    const {
      params: { reference }
    } = props.match;

    return (
      <GetBookingQuery reference={reference} query={query} centerLoader={options.centerLoader}>
        {(booking, refetch) => <Component booking={booking} refetch={refetch} {...props} />}
      </GetBookingQuery>
    );
  });

export default withBooking;
